<template>
    <div v-if="supplier === 'AWIN'" class="flex justify-start items-center py-1 gap-2 has-tooltip">
        <img class="w-6 h-6 rounded-md border border-gray-200" src="https://logos.ntropy.com/awin.com" />
        Awin
    </div>
    <div v-else-if="supplier === 'PARTNERIZE'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/partnerize.com" />
        Partnerize
    </div>
    <div v-else-if="supplier === 'TRADEDOUBLER'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/tradedoubler.com" />
        Tradedoubler
    </div>
    <div v-else-if="supplier === 'CJAFFILIATE'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/cj.com" />
        CJ Affiliate
    </div>
    <div v-else-if="supplier === 'IMPACT'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/impact.com" />
        Impact.com
    </div>
    <div v-else-if="supplier === 'LUX'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="../assets/lux_logo.jpeg" />
        LUX Rewards
    </div>
    <div v-else-if="supplier === 'TRC'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/therewardcollection.com" />
        The Reward Collection
    </div>
    <div v-else-if="supplier === 'TILLO'" class="flex justify-start items-center py-1 gap-2">
        <img class="w-6 h-6 rounded-md" src="https://logos.ntropy.com/tillo.io" />
        Tillo
    </div>
    <div v-else class="flex justify-start items-center py-1">
        {{ supplier }}
    </div>
</template>

<script>
export default {
	name:"Logo-And-Text",
	components:{
	},
	props:{
		supplier:{
			type:String
		}
	},
	data(){
		return{

		}
	},
	mounted(){

	}

}
</script>

<style>

</style>